module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar-container"
  }, [(_vm.title) ? _c('div', {
    staticClass: "progress-bar--title"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "progress-bar",
    class: [{
      'has-content': !_vm.isMini
    }, _vm.advancement]
  }, [_c('div', {
    staticClass: "progress-bar--progression",
    style: ('width: ' + _vm.percentage + '%')
  }, [(!_vm.isMini) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.percentage.toFixed(0)) + "\n      ")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e005791","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/ProgressBar.vue
// module id = 1936
// module chunks = 0